import React from "react";
import { useDisclosure, CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { SetOnPremOrderListingColumnsConfigDialog } from "./SetOnPremOrderListingColumnsConfigDialog";
export interface SetOnPremOrderListingColumnsConfigButtonProps {
    pageSize: number;
    setPageSize(pageSize: number): void;
}
export const SetOnPremOrderListingColumnsConfigButton: React.VFC<SetOnPremOrderListingColumnsConfigButtonProps> = (
    props: SetOnPremOrderListingColumnsConfigButtonProps
) => {
    const { isOpen, onClose, onOpen } = useDisclosure();
    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdRead]}>
            <CommandBarButton icon={"Settings"} onClick={onOpen} text={`Config`} />
            {isOpen && (
                <SetOnPremOrderListingColumnsConfigDialog
                    key={String(isOpen)}
                    isOpen={isOpen}
                    onClose={onClose}
                    pageSize={props.pageSize}
                    setPageSize={props.setPageSize}
                />
            )}
        </AuthorizationWrapper>
    );
};
